// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 195 ? "bf5f3635" : chunkId) + "." + {"195":"29de7184fff162e2","268":"46d9fc86b14d7222","647":"3b6ae5bb04494cbf"}[chunkId] + ".js";
};